import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'components/atoms/Card';
import { Text, Flex, Box } from 'rebass/styled-components';
import { Tooltip } from '@getro/rombo';
import { Copy } from 'lucide-react';

export const ContactEmailDropdownContent = ({ workEmails, personalEmail }) => {
  const [copiedEmail, setCopiedEmail] = useState(null);

  const handleCopyEmail = (event, email) => {
    event.stopPropagation(); // avoid closing the dropdown
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(email);
      setCopiedEmail(email);
    }
  };

  const emails = [...(workEmails ?? []), personalEmail].filter(Boolean);

  return (
    <Card
      variant="card.default"
      sx={{
        width: 'auto',
        padding: '8px 16px',
        fontSize: '12px',
        lineHeight: '28px',
      }}
    >
      {emails.length === 0 && (
        <Text fontSize="14px" color="text.main">
          We couldn’t find any email for this contact.
        </Text>
      )}
      {emails.length > 0 &&
        emails?.map((email) => (
          <Flex key={email} alignItems="center" color="text.main" sx={{ gap: '24px' }}>
            <Flex alignItems="baseline" sx={{ flex: 1, gap: '8px', fontSize: '14px' }}>
              <Text as="span" sx={{ userSelect: 'all' }}>
                {email}
              </Text>
              <Text
                as="span"
                sx={{ color: 'text.subtle', textTransform: 'uppercase', fontSize: '10px', letterSpacing: '1px' }}
              >
                {email === personalEmail ? 'Personal' : 'Work'}
              </Text>
            </Flex>
            <Box
              as="span"
              sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', color: 'neutral.500' }}
              onClick={(event) => handleCopyEmail(event, email)}
            >
              <Tooltip
                position="right"
                content={<Text fontSize="12px">{copiedEmail === email ? 'Copied!' : 'Copy email'}</Text>}
                trigger={<Copy size={16} />}
              />
            </Box>
          </Flex>
        ))}
    </Card>
  );
};

ContactEmailDropdownContent.propTypes = {
  workEmails: PropTypes.array.isRequired,
  personalEmail: PropTypes.string,
};

ContactEmailDropdownContent.defaultProps = {
  personalEmail: null,
};
